const css = `.system-notification-banner {
  margin-bottom: 16px;
  width: 100%;
  border-radius: 0;
  border-left: none;
  border-right: none;
}
.system-notification-banner .alert-icon {
  margin-top: 4px;
  margin-bottom: auto;
}
.system-notification-banner .system-notification-message {
  font-size: var(--font-size-sm);
  line-height: var(--line-height-normal);
  color: var(--text);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9yZW5kZXIvcHJvamVjdC9zcmMvc3JjL2NvbXBvbmVudHMvU3lzdGVtTm90aWZpY2F0aW9uQmFubmVyIiwic291cmNlcyI6WyJTeXN0ZW1Ob3RpZmljYXRpb25CYW5uZXIuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBOztBQUdGO0VBQ0U7RUFDQTtFQUNBIiwic291cmNlc0NvbnRlbnQiOlsiLnN5c3RlbS1ub3RpZmljYXRpb24tYmFubmVyIHtcbiAgbWFyZ2luLWJvdHRvbTogMTZweDtcbiAgd2lkdGg6IDEwMCU7XG4gIGJvcmRlci1yYWRpdXM6IDA7XG4gIGJvcmRlci1sZWZ0OiBub25lO1xuICBib3JkZXItcmlnaHQ6IG5vbmU7XG5cbiAgLmFsZXJ0LWljb24ge1xuICAgIG1hcmdpbi10b3A6IDRweDtcbiAgICBtYXJnaW4tYm90dG9tOiBhdXRvO1xuICB9XG5cbiAgLnN5c3RlbS1ub3RpZmljYXRpb24tbWVzc2FnZSB7XG4gICAgZm9udC1zaXplOiB2YXIoLS1mb250LXNpemUtc20pO1xuICAgIGxpbmUtaGVpZ2h0OiB2YXIoLS1saW5lLWhlaWdodC1ub3JtYWwpO1xuICAgIGNvbG9yOiB2YXIoLS10ZXh0KTtcbiAgfVxufVxuIl19 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
